import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import EmailConfirmationAlert from "../../../components/Common/EmailConfirmationAlert";
import Discussions from "../../../components/Dashboard/Discussions";
import LookingForHosts from "../../../components/Dashboard/LookingForHosts";
import EventsList from "../../../components/Dashboard/EventsList";
import { getAllEvents } from "../../../redux/dispatchers/events.dispatcher";
import { useDispatch, useSelector } from "react-redux";
import { getAllForums } from "../../../redux/dispatchers/forum.dispatcher";
import { getAllGroups } from "../../../redux/dispatchers/groups.dispatcher";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { upcomingEvents, pastEvents } = useSelector((state) => state.events);

  const { allForums } = useSelector((state) => state.forums);
  const { allGroups } = useSelector((state) => state.groups);

  useEffect(() => {
    dispatch(getAllEvents());
    dispatch(getAllForums());
    dispatch(getAllGroups());
  }, []);
  return (
    <Layout heading="Dashboard" noBtn>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <EmailConfirmationAlert /> */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, md: 5 }}>
            <Discussions allForums={allForums} />
            <LookingForHosts allGroups={allGroups} />
          </Grid>
          <Grid item size={{ xs: 12, md: 7 }}>
            <EventsList eventsList={upcomingEvents} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default Dashboard;
